module.exports = __webpack_public_path__ + "img/4-10.6279748f.png";